<template>
  <div class="page-content">
    <div class="container mx-auto py-12">
      <!-- 头部区域 -->
      <header class=" bg-gradient-primary header-gradient text-white py-20 px-6 md:px-12">
        <div class="max-w-5xl mx-auto text-center">
          <h1 class="text-4xl md:text-5xl font-bold mb-6">大都会展数字月刊</h1>
          <div class="text-lg text-white/90 max-w-3xl mx-auto">
            <p>促进会展行业深度交流与合作，搭建信息共享与资源对接桥梁，汇聚行业精英、分享前沿动态、分析市场趋势，共同推动会展行业创新发展与转型升级。</p>
          </div>
        </div>
      </header>

      <!-- 顶部区域：会员专享月刊 -->
      <section class="mb-16">
        <div class="flex justify-between items-center mb-8">
          <h2 class="section-title">会员专享月刊</h2>
          <!-- 移除会员专享区域的"查看往年"按钮 -->
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <!-- 12月月刊 -->
          <div class="magazine-card">
            <div class="magazine-cover">
              <img src="../assets/images/monthly/ddhzyk-img12.jpg" alt="2025年12月大都会展月刊">
              <div class="members-only-badge">成为会员立即查看</div>
            </div>
            <div class="month-label">2025年12月</div>
          </div>

          <!-- 11月月刊 -->
          <div class="magazine-card">
            <div class="magazine-cover">
              <img src="../assets/images/monthly/ddhzyk-img11.jpg" alt="2025年11月大都会展月刊">
              <div class="members-only-badge">成为会员立即查看</div>
            </div>
            <div class="month-label">2025年11月</div>
          </div>

          <!-- 10月月刊 -->
          <div class="magazine-card">
            <div class="magazine-cover">
              <img src="../assets/images/monthly/ddhzyk-img10.jpg" alt="2025年10月大都会展月刊">
              <div class="members-only-badge">成为会员立即查看</div>
            </div>
            <div class="month-label">2025年10月</div>
          </div>
        </div>
        <!-- 移除会员专享区域的移动端"查看往年"按钮 -->
      </section>

      <!-- 下方区域：2025年月刊合集 -->
      <section>
        <div class="flex justify-between items-center mb-8">
          <h2 class="section-title">2025年月刊合集</h2>
          <a href="#" class="view-archive-btn hidden md:block">
            <i class="fas fa-calendar-alt mr-2"></i>查看往年
          </a>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6">
          <!-- 9月月刊 -->
          <div class="magazine-card">
            <div class="magazine-cover">
              <img src="../assets/images/monthly/ddhzyk-img9.jpg" alt="2025年9月大都会展月刊">
              <div class="free-badge">免费查看</div>
            </div>
            <div class="month-label">2025年9月</div>
          </div>

          <!-- 8月月刊 -->
          <div class="magazine-card">
            <div class="magazine-cover">
              <img src="../assets/images/monthly/ddhzyk-img8.jpg" alt="2025年8月大都会展月刊">
              <div class="free-badge">免费查看</div>
            </div>
            <div class="month-label">2025年8月</div>
          </div>

          <!-- 7月月刊 -->
          <div class="magazine-card">
            <div class="magazine-cover">
              <img src="../assets/images/monthly/ddhzyk-img7.jpg" alt="2025年7月大都会展月刊">
              <div class="free-badge">免费查看</div>
            </div>
            <div class="month-label">2025年7月</div>
          </div>

          <!-- 6月月刊 -->
          <div class="magazine-card">
            <div class="magazine-cover">
              <img src="../assets/images/monthly/ddhzyk-img6.jpg" alt="2025年6月大都会展月刊">
              <div class="free-badge">免费查看</div>
            </div>
            <div class="month-label">2025年6月</div>
          </div>

          <!-- 5月月刊 -->
          <div class="magazine-card">
            <div class="magazine-cover">
              <img src="../assets/images/monthly/ddhzyk-img5.jpg" alt="2025年5月大都会展月刊">
              <div class="free-badge">免费查看</div>
            </div>
            <div class="month-label">2025年5月</div>
          </div>

          <!-- 4月月刊 -->
          <div class="magazine-card">
            <div class="magazine-cover">
              <img src="../assets/images/monthly/ddhzyk-img4.jpg" alt="2025年4月大都会展月刊">
              <div class="free-badge">免费查看</div>
            </div>
            <div class="month-label">2025年4月</div>
          </div>

          <!-- 3月月刊 -->
          <div class="magazine-card">
            <div class="magazine-cover">
              <img src="../assets/images/monthly/ddhzyk-img3.jpg" alt="2025年3月大都会展月刊">
              <div class="free-badge">免费查看</div>
            </div>
            <div class="month-label">2025年3月</div>
          </div>

          <!-- 2月月刊 -->
          <div class="magazine-card">
            <div class="magazine-cover">
              <img src="../assets/images/monthly/ddhzyk-img2.jpg" alt="2025年2月大都会展月刊">
              <div class="free-badge">免费查看</div>
            </div>
            <div class="month-label">2025年2月</div>
          </div>

          <!-- 1月月刊 -->
          <div class="magazine-card">
            <div class="magazine-cover">
              <img src="../assets/images/monthly/ddhzyk-img1.jpg" alt="2025年1月大都会展月刊">
              <div class="free-badge">免费查看</div>
            </div>
            <div class="month-label">2025年1月</div>
          </div>
        </div>
        <div class="text-center mt-8 md:hidden">
          <a href="#" class="view-archive-btn inline-block">
            <i class="fas fa-calendar-alt mr-2"></i>查看往年
          </a>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  name: "Monthly"
}
</script>

<style scoped>
.bg-gradient-primary {
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
  border-radius: 20px 20px 0px 0px;
  margin-bottom: 20px;
}

.page-content{
  padding-top: 20px;
  padding-bottom: 20px;
}
body {
  font-family: 'Noto Sans SC', sans-serif;
  background-color: #f8f9fa;
  color: #333;
}

.container {
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 20px;
}

.magazine-card {
  transition: transform 0.3s ease;
}

.magazine-card:hover {
  transform: translateY(-5px);
}

.magazine-cover {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.magazine-cover img {
  width: 100%;
  height: auto;
  transition: transform 0.5s ease;
}

.magazine-cover:hover img {
  transform: scale(1.05);
}

.members-only-badge {
  position: absolute;
  top: 15px;
  right: 15px;
  background-color: #e53e3e;
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
  z-index: 10;
}

.free-badge {
  position: absolute;
  top: 15px;
  right: 15px;
  background-color: #38a169;
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
  z-index: 10;
}

.month-label {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  margin-top: 12px;
  color: #2d3748;
}

.section-title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 24px;
  color: #1a202c;
  border-bottom: 3px solid #4299e1;
  padding-bottom: 8px;
  display: inline-block;
}

.header-bg {
  background: linear-gradient(135deg, #4299e1 0%, #3182ce 100%);
  padding: 3rem 0;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.view-archive-btn {
  background-color: #4299e1;
  color: white;
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.view-archive-btn:hover {
  background-color: #3182ce;
}

@media (max-width: 1200px) {
  .container {
    padding: 0 15px;
  }
}

@media (max-width: 768px) {
  .section-title {
    font-size: 20px;
  }

  .month-label {
    font-size: 16px;
  }

  .header-bg {
    padding: 2rem 0;
  }
}

/* 提升顶部标题部分的样式 */
.enhanced-title {
  font-size: 4rem;
  font-weight: 800;
  color: white;
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;
  letter-spacing: -0.5px;
  position: relative;
  display: inline-block;
}

.enhanced-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 4px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent);
  border-radius: 2px;
}

.subtitle {
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.9);
  margin-top: 1.5rem;
  letter-spacing: 0.5px;
  position: relative;
  display: inline-block;
}

.subtitle::before, .subtitle::after {
  content: '•';
  margin: 0 10px;
  color: rgba(255, 255, 255, 0.7);
}

/* 装饰元素 */
.decorative-circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  z-index: 0;
}

.circle-1 {
  width: 200px;
  height: 200px;
  top: -100px;
  left: 10%;
}

.circle-2 {
  width: 150px;
  height: 150px;
  bottom: -75px;
  right: 15%;
}

.header-content {
  position: relative;
  z-index: 1;
}

/* 装饰性图标 */
.header-icon {
  font-size: 2.5rem;
  color: rgba(255, 255, 255, 0.9);
  margin: 0 15px;
  display: inline-block;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.header-icon:nth-child(2) {
  animation-delay: 0.5s;
}

.header-icon:nth-child(4) {
  animation-delay: 1s;
}
</style>
